import React, { useState, useEffect, useCallback } from 'react';
import AgentsTiles from './AgentsTiles';
import AgentsGrid from './AgentsGrid';
import AgentsFilter from './AgentsFilter';
import Tools from '../utils/Tools';
import { useFilter } from '../contexts/FilterContext';


function AgentsPage() {
  const { filters, setFilters } = useFilter();
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [allAgentInfo, setAllAgentInfo] = useState([]);
  const [queues, setQueues] = useState([]);
  const [initiationMethods, setInitiationMethods] = useState([]);
  const [showTrends, setShowTrends] = useState(false);

  // Todo: refactor
  function formatDateToYYYYMMDD(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  // Fetch summary data from server whenever filters change
  useEffect(() => {
    setLoadingSummary(true);
    const queryParams = new URLSearchParams();
    if (filters.agent && filters.agent.value) {
      queryParams.append('agent', filters.agent.value);
    }
    if (filters.queue && filters.queue.length > 0) {
      filters.queue.forEach(queue => {
        queryParams.append("queue", queue.value);
      });
    }
    if (filters.initiationMethod && filters.initiationMethod.length > 0) {
      filters.initiationMethod.forEach(initiationMethod => {
        queryParams.append("initiationMethod", initiationMethod.value);
      });
    }
    if (filters.dateRange) {
      queryParams.append('dateRange', filters.dateRange.value);
    }
    if (!filters.excludeWeekends) {
      queryParams.append("excludeWeekends", filters.excludeWeekends);
    }
    if (filters.dateStart) {
      queryParams.append('dateStart', formatDateToYYYYMMDD(filters.dateStart));
    }
    if (filters.dateEnd) {
      queryParams.append('dateEnd', formatDateToYYYYMMDD(filters.dateEnd));
    }
    Tools.sendRequest("get-all-agents-info", queryParams.toString()).then((response) => {
      console.log('DEBUG - GOT AGENTS', response);
      setAllAgentInfo(response.allAgentInfo);
      setQueues(
        Object.keys(response.queueCounts)
          .map((a) => ({
            value: a,
            label: a,
            count: response.queueCounts[a],
          }))
          .sort((a, b) => b.count - a.count) // Sort descending by count
      );
      setInitiationMethods(
        Object.keys(response.initiationMethodCounts)
          .map((a) => ({
            value: a,
            label: a,
            count: response.initiationMethodCounts[a],
          }))
          .sort((a, b) => b.count - a.count) // Sort descending by count
      );
      setLoadingSummary(false);
    });
  }, [filters]);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, [setFilters]);

  return (
    <div className="container mx-auto p-4">
      <AgentsFilter
        filters={filters}
        setFilters={handleFilterChange}
        updateShowTrends={setShowTrends}
        allAgentInfo={allAgentInfo}
        queues={queues}
        initiationMethods={initiationMethods}
      />
      {(loadingSummary) ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <>
          <AgentsTiles
            allAgentInfo={allAgentInfo}
            showTrends={showTrends}
          />
          <AgentsGrid allAgentInfo={allAgentInfo} filters={filters} />
        </>
      )}
    </div>
  );
}

export default AgentsPage;